import axios from "axios";

export function getJudges(){
    return axios.request({
        method:'POST',
        url:'api/tabulation/getJudges'
    });
}
export function addJudge(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/addJudge'
    });
}
export function getParticipants(){
    return axios.request({
        method:'POST',
        url:'api/tabulation/getParticipants'
    });
}
export function addParticipant(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/addParticipant'
    });
}
export function getVoteResults(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/getVoteResults'
    });
}
export function getListOfGames(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/getListOfGames'
    });
}
export function getListOfGroups(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/getListOfGroups'
    });
}
export function addGame(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/addGame'
    });
}
export function deleteGame(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteGame'
    });
}
export function updateGame(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/updateGame'
    });
}
export function updateWinner(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/updateWinner'
    });
}
export function resetAllWinner(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/resetAllWinner'
    });
}
export function getGameResults(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/getGameResults'
    });
}
export function addGroup(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/addGroup'
    });
}
export function deleteGroup(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteGroup'
    });
}
export function updateGroup(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/updateGroup'
    });
}
export function resetGroup(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/resetGroup'
    });
}
export function updateVoteSettings(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/updateVoteSettings'
    });
}
export function deleteAllParticipants(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteAllParticipants'
    });
}
export function deleteParticipant(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteParticipant'
    });
}
export function updateParticipant(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/updateParticipant'
    });
}
export function deleteVotes(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/deleteVotes'
    });
}